import { FC } from "react";
import viewersIcon from "src/assets/icons/eye.svg";

const EYE_ICON_ALT_TEXT = "eye";

const MAX_VIEWS = 99999;

interface Props {
  viewsCount: number;
}

export const ViewersLabel: FC<Props> = ({ viewsCount }) => {
  const count = viewsCount > MAX_VIEWS ? `${MAX_VIEWS}+` : viewsCount;

  return (
    <div className="flex gap-1 max-w-30">
      <img
        className="min-w-6 min-h-6"
        src={viewersIcon}
        alt={EYE_ICON_ALT_TEXT}
      />
      <p className="text-lg text-purple-base">{count}</p>
    </div>
  );
};
